export default {
  GENERAL: 'General feedback or question',
  CULTURE_ISSUES: 'Culture Issues',
  HARASSMENT_OR_BIAS: 'Harassment or bias',
  DIVERSITY: 'Diversity, equity and inclusion',
}
